<div class="flex flex-column align-items-center mt-8">
    <form (submit)="login()" class="flex flex-column gap-2 w-8 md:w-6 lg:w-4 xl:w-3">

        <h1 class="text-center">i-Host Billing Admin</h1>

        <div class=" flex flex-column gap-2 w-full">
            <label for="username">Username</label>
            <input pInputText id="username" name="usernam" aria-describedby="name-help" [(ngModel)]="username"
                required />
        </div>

        <div class="flex flex-column gap-2 w-full">
            <label for="password">Password</label>
            <p-password [toggleMask]="true" id="password" name="password" aria-describedby="name-help"
                styleClass="w-full" [(ngModel)]="password" [feedback]="false" required />
        </div>

        <p-button type="submit" label="Login" class="mt-4 mr-2 w-full" styleClass="w-full" severity="success" />
    </form>
</div>